export const OTP_TYPES = {
  EMAIL_VERIFICATION: 'emailVerification',
  PASSWORD_RESET: 'passwordReset',
  WITHDRAWAL_CONFIRMATION: 'withdrawal',
}

export const OTP_LENGTH = process.env.REACT_APP_OTP_LENGTH ? parseInt(process.env.REACT_APP_OTP_LENGTH) : 6;
export const OTP_EXPIRATION = process.env.REACT_APP_OTP_EXPIRATION ? parseInt(process.env.REACT_APP_OTP_EXPIRATION) : 60;